import React from "react";
import { Link } from "react-router-dom";
import "../App.css";

const DEFAULT_TITLE =
  "Sua empresa merece uma contabilidade que acompanha o seu crescimento.";
const DEFAULT_TEXT =
  "Conte com uma equipe preparada para cuidar das obrigações fiscais, legais e contábeis enquanto você foca no desenvolvimento do seu negócio.";

/**
 * Seção de chamada para ação — card com degradê de azul flutuando sobre
 * um fundo claro.
 *
 * Props:
 * - title, text, buttonLabel, buttonTo: conteúdo (todos têm um valor padrão)
 * - variant: "centered" (padrão, usada na Home) | "split" (texto à
 *   esquerda e botão à direita, usada em Serviços)
 */
export default function CTA({
  title = DEFAULT_TITLE,
  text = DEFAULT_TEXT,
  buttonLabel = "Solicitar Proposta",
  buttonTo = "/contato",
  variant = "centered",
}) {
  return (
    <section className={"cta cta--" + variant}>
      <div className="cta__container">
        <div className="cta__blob cta__blob--a" aria-hidden="true" />
        <div className="cta__blob cta__blob--b" aria-hidden="true" />

        <div className="cta__content">
          <h2 className="cta__title">{title}</h2>
          <p className="cta__text">{text}</p>
        </div>

        <Link to={buttonTo} className="cta__button">
          {buttonLabel}
        </Link>
      </div>
    </section>
  );
}
